export function CroHeadCompose(page, rowL, ll, dataUrl) {
    var doc = ll;
    var _y = rowL;
    var _space = page.spacingunit;
    var imgWidth = 55;
    var imgHeight = 25;
    var pageWidth = doc.internal.pageSize.getWidth();

    var imageX = (pageWidth / 2) - (imgWidth / 2);

    doc.addImage(dataUrl, 'JPEG', imageX, page.headerFromTop, imgWidth, imgHeight);
    _y += _space * 4;

    return _y;
}

export function CroBodyCompose(page, rowL, ll, data, user) {
    var doc = ll;
    var _y = rowL;
    var _space = page.spacingunit;
    var margin = 10;
    var pageWidth = doc.internal.pageSize.getWidth();
    var columns = pageWidth / 3;
    console.log('data', data)

    //current date
    var today = new Date().toDateString();

    //user
    const branch = user.branches.find(branch => branch.defaultBranch === true);

    doc.setFont("times", "bold");
    doc.text('OCEAN TRANSPORT GROUP OF COMPANIES INC.', (pageWidth / 2), _y, null, null, 'center');
    doc.setFont("times", "normal");

    _y += _space;
    doc.text('CARGO RELEASE ORDER', (pageWidth / 2), _y, null, null, 'center');
    _y += _space;

    doc.text(`Date: ${today}`, margin, _y);
    doc.text(`Booking Reference No : ${data.bookingRef}`, (pageWidth - margin), _y, null, null, 'right');
    _y += _space;
    doc.text(`CRO No: ${data.cargorReleaseOrderId}`, margin, _y);
    doc.text(`Branch: ${branch.branchCode}`, (pageWidth - margin), _y, null, null, 'right');
    _y += _space * 2;

    // doc.text(`Old Booking Ref`, margin, _y);
    // doc.setFont("times", "bold");
    // var OldBookingRef = data.oldBookingRef ? data.oldBookingRef : '';
    // doc.text(`:${OldBookingRef}`, (margin + 50), _y);
    // doc.setFont("times", "normal");

    // _y += _space;
    // doc.text(`Old Waybill Ref`, margin, _y);
    // doc.setFont("times", "bold");
    // var OldWaybillRef = data.oldWaybillRef ? data.oldWaybillRef : '';
    // doc.text(`:${OldWaybillRef}`, (margin + 50), _y);
    // doc.setFont("times", "normal");
    
    // _y += _space * 2;

    doc.text(`Shipper`, margin, _y);
    doc.setFont("times", "bold");
    doc.text(`:${data.shipper}`, (margin + 50), _y);
    doc.setFont("times", "normal");

    if(data.shipperPreferedName){
        _y += _space;
        doc.text(`Shipper Preferred Name`, margin, _y);
        doc.setFont("times", "bold");
        doc.text(`:${data.shipperPreferedName ? data.shipperPreferedName : ''}`, (margin + 50), _y);
        doc.setFont("times", "normal");
    }

    _y += _space * 2;
    doc.text(`Consignee`, margin, _y);
    doc.setFont("times", "bold");
    doc.text(`:${data.consignee}`, (margin + 50), _y);
    doc.setFont("times", "normal");
    
    if(data.consigneePreferedName){
        _y += _space;
        doc.text(`Consignee Preferred Name`, margin, _y);
        doc.setFont("times", "bold");
        doc.text(`:${data.consigneePreferedName ? data.consigneePreferedName : ''}`, (margin + 50), _y);
        doc.setFont("times", "normal");
    }
    
    _y += _space;
    doc.text(`Contact Person`, margin, _y);
    doc.setFont("times", "bold");
    doc.text(`:${data.consigneeContactPerson ? data.consigneeContactPerson : ''}`, (margin + 50), _y);
    doc.setFont("times", "normal");
    
    _y += _space;
    doc.text(`Contact No`, margin, _y);
    doc.setFont("times", "bold");
    doc.text(`:${data.consigneeContactNum ? data.consigneeContactNum : ''}`, (margin + 50), _y);
    doc.setFont("times", "normal");
    
    _y += _space * 2;
    doc.text(`Vessel`, margin, _y);
    doc.setFont("times", "bold");
    doc.text(`:${data.vessel ? data.vessel : ''}`, (margin + 50), _y);
    doc.setFont("times", "normal");
    _y += _space;

    doc.text(`Origin`, margin, _y);
    doc.setFont("times", "bold");
    doc.text(`:${data.origin ? data.origin : ''}`, (margin + 50), _y);
    doc.setFont("times", "normal");
    _y += _space;

    doc.text(`Departure Date`, margin, _y);
    doc.setFont("times", "bold");
    let etd_datetime = new Date(data.etd)
    let etd_date = (etd_datetime.getMonth() + 1) + "/" + etd_datetime.getDate() + "/" + etd_datetime.getFullYear();
    doc.text(`:${etd_date}`, (margin + 50), _y);
    doc.setFont("times", "normal");
    _y += _space;

    doc.text(`Destination`, margin, _y);
    doc.setFont("times", "bold");
    doc.text(`:${data.destination ? data.destination : ''}`, (margin + 50), _y);
    doc.setFont("times", "normal");
    _y += _space;

    doc.text(`Arrival Date`, margin, _y);
    doc.setFont("times", "bold");
    let arrivalDate_datetime = new Date(data.arrivalDate)
    let arrivalDate_date = (arrivalDate_datetime.getMonth() + 1) + "/" + arrivalDate_datetime.getDate() + "/" + arrivalDate_datetime.getFullYear();
    doc.text(`:${arrivalDate_date}`, (margin + 50), _y);
    doc.setFont("times", "normal");
    _y += _space * 2;

    doc.text(`Commodity`, margin, _y);
    doc.setFont("times", "bold");
    doc.text(`:${data.goods ? data.goods : ''}`, (margin + 50), _y);
    doc.setFont("times", "normal");
    _y += _space;

    doc.text(`Package`, margin, _y);
    doc.setFont("times", "bold");
    doc.text(`:${data.packaging ? data.packaging : ''}`, (margin + 50), _y);
    doc.setFont("times", "normal");
    _y += _space;

    doc.text(`Seal Num`, margin, _y);
    doc.setFont("times", "bold");
    doc.text(`:${data.sealNum ? data.sealNum : ''}`, (margin + 50), _y);
    doc.setFont("times", "normal");
    _y += _space;

    doc.line(margin, _y, (pageWidth - margin), _y);
    _y += _space;
    doc.text(`QTY`, margin, _y);
    doc.text(`SIZE`, columns, _y);
    doc.text(`CONTAINER VAN NO.`, (columns * 2), _y);
    _y += 2;
    doc.line(margin, _y, (pageWidth - margin), _y);
    _y += _space;

    doc.setFont("times", "bold");
    doc.text(`${data.quantityInTeu ? data.quantityInTeu : data.quantity ? data.quantity : ''}`, margin, _y);
    doc.text(`${data.size ? data.size : ''}`, columns, _y);
    doc.text(`${data.containerVanNum ? data.containerVanNum : ''}`, (columns * 2), _y);
    doc.setFont("times", "normal");
    _y += 2;
    doc.line(margin, _y, (pageWidth - margin), _y);
    _y += _space * 2;

    if(data.modeOfDelivery === "PTP" || data.modeOfDelivery === "DTP"){
        doc.text(`Remarks`, margin, _y);
        doc.setFont("times", "bold");
        var ReleaseType = "";
        if(data.isStripping){
            if(data.strippingType === "011") {
                ReleaseType = "CY Stripping Mano";
            }
            else if(data.strippingType === "010") {
                ReleaseType = "CY Stripping Area";
            }
            else if(data.strippingType === "ALL") {
                ReleaseType = "CY Stripping Area and CY Stripping Mano";
            }
        }
        else {
            ReleaseType = "Van out";
        }
        doc.text(`:${ReleaseType}`, (margin + 50), _y);
        doc.setFont("times", "normal");
        _y += _space * 2;
    }

    doc.text(`Remarks`, margin, _y);
    doc.setFont("times", "bold");
    var Remarks = '';
    if(data.isStripping){
        if(data.remarks){ Remarks = "STRIPPING, " + data.remarks; } 
        else { Remarks = "STRIPPING"; }
    } else {
        if(data.remarks){ Remarks = data.remarks; }
    }
    doc.text(`:${Remarks}`, (margin + 50), _y);
    doc.setFont("times", "normal");
    _y += _space * 2;

    doc.text(`CY Pull-Out (Loaded)`, margin, _y);
    doc.setFont("times", "bold");
    doc.text(`:${data.cyPullOutName ? data.cyPullOutName : ''}`, (margin + 50), _y);
    doc.setFont("times", "normal");
    _y += _space * 2;

    doc.text(`Issued By`, margin, _y);
    doc.text(`Released By`, (columns * 2), _y);
    _y += 30;

    doc.setFont("times", "bold");
    doc.text(`${user.name ? user.name : ''}`, margin, _y);
    doc.text(`${data.clearedByName ? data.clearedByName : ''}`, (columns * 2), _y);
    doc.setFont("times", "normal");
    _y += 2;
    // doc.line(margin, _y, (doc.getTextWidth(user.name) + margin), _y);
    doc.line(margin, _y, 70, _y);
    doc.line(140, _y, 200, _y);

    _y += _space;
    doc.text(`Signature over Printed Name`, margin, _y);
    doc.text(`Signature over Printed Name`, (columns * 2), _y);

    _y += _space * 2;

    //this is mock up
    const txt = doc.splitTextToSize(
        'Note: We would highly appreciate it if you can pull-out your container/s within the storage free time provided. In excess, a storage fee of P900.00/ TEU per day shall be charged accordingly.',
        (pageWidth - (margin * 2))
    );
    doc.text(txt, margin, _y);
}